// extracted by mini-css-extract-plugin
module.exports = {"header":"OrderDetailForm_header__2-Xef","actions":"OrderDetailForm_actions__1MhWQ"};